import { call, put } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as PermissionsActions } from "../ducks/permissions";
import { Creators as LoadingActions } from "../ducks/loading";
import { Creators as ErrorActions } from "../ducks/error";
import moment from "moment";

export function* getPermissions() {
  try {
    const { data } = yield call(api.get, `authenticated/user`);
    let permissions_name = data.permissions_name;
    data.communications = data.communications.map(comunicado => {
      comunicado.sent_at = moment(comunicado.sent_at).format("DD/MM/YYYY");
      return comunicado;
    });
    yield put(
      PermissionsActions.getPermissionsSuccess(
        permissions_name,
        data.avatar,
        data.master,
        data.id,
        data.communications,
        data.pesquisador_module,
        data.pesquisador,
        data.super_user,
        data.see_general,
        data.name,
        data.company,
        data.notifications,
        data.chat_key,
        data.url_click_to_call,
        data.token_click_to_call,
        data.account_click_to_call,
        data.ramal
      )
    );
  } catch (err) {
    if (err.response.status === 409) {
      yield put(
        ErrorActions.openError(
          "Alguém efetuou login utilizando a sua conta. Por favor, vá para a página de login e entre novamente."
        )
      );
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getFullComunicados() {
  try {
    let { data } = yield call(api.get, `communications/my-communications`);
    data = data.map(comunicado => {
      comunicado.sent_at = moment(comunicado.sent_at).format("DD/MM/YYYY");
      return comunicado;
    });
    yield put(PermissionsActions.getFullComunicadosSuccess(data));
  } catch (err) {
    if (err.response.status === 409) {
      if (err.response.data) {
        if (err.response.data.error) {
          let message = err.response.data.error.message;
          let erros = "";
          if (
            err.response.data.error.errors &&
            err.response.data.error.errors.length > 0
          ) {
            erros = err.response.data.error.errors
              .map(err => `${err} <br/>`)
              .join("");
          }
          yield put(ErrorActions.openError(`${message}<br/>${erros}`));
        } else {
          yield put(
            ErrorActions.openError("Ocorreu um erro não identificado.")
          );
        }
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    }
  }
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/permissions.js